import Color from "color";

const noColor = "#494949";
export function useGetUniqueColor() {
  const usedColors: Record<string, number> = {};
  const getColor = (color: string | null | undefined) => {
    usedColors[color ?? noColor] = (usedColors[color ?? noColor] ?? 0) + 1;
    const c = color
      ? Color(color).darken((usedColors[color] - 1) * 0.2)
      : Color(noColor).lighten((usedColors[noColor] - 1) * 0.3);

    return c.hex();
  };

  return getColor;
}
